const defaultBrand = {
  appName: 'Voice Analytics',
  tagline: 'call insights',
  logoUrl: '',
  faviconUrl: '/vite.svg',
  primary: '#0f172a',
  primaryLight: '#334155',
  accent: '#06b6d4',
  accentHover: '#0891b2',
  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',
  surface: '#ffffff',
  background: '#f8fafc',
  textMain: '#0f172a',
  textMuted: '#64748b',
};

export function applyBrand(config) {
  const brand = { ...defaultBrand, ...config };
  const root = document.documentElement;

  root.style.setProperty('--color-primary', brand.primary);
  root.style.setProperty('--color-primary-light', brand.primaryLight);
  root.style.setProperty('--color-accent', brand.accent);
  root.style.setProperty('--color-accent-hover', brand.accentHover);
  root.style.setProperty('--color-success', brand.success);
  root.style.setProperty('--color-warning', brand.warning);
  root.style.setProperty('--color-danger', brand.danger);
  root.style.setProperty('--color-surface', brand.surface);
  root.style.setProperty('--color-background', brand.background);
  root.style.setProperty('--color-text-main', brand.textMain);
  root.style.setProperty('--color-text-muted', brand.textMuted);

  if (brand.faviconUrl) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = brand.faviconUrl;
  }

  if (brand.appName) {
    document.title = brand.appName;
  }

  return brand;
}

export function getBrand() {
  const saved = localStorage.getItem('brand_config');
  const config = saved ? JSON.parse(saved) : {};
  return { ...defaultBrand, ...config };
}

export function updateBrand(config) {
  const merged = { ...getBrand(), ...config };
  localStorage.setItem('brand_config', JSON.stringify(merged));
  return applyBrand(merged);
}
